import React     from 'react';
import PropTypes from 'prop-types';
import {
    EyeOpenIcon,
    EyeClosedIcon,
} from '../';

import './password-input.scss';

class PasswordInput extends React.Component {
    static propTypes = {
        label: PropTypes.oneOfType( [
            PropTypes.string,
            PropTypes.object
        ] ),
        name: PropTypes.string,
        tabIndex: PropTypes.oneOfType( [
            PropTypes.string,
            PropTypes.number
        ] ),
        onChange: PropTypes.func,
        onKeyPress: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        helpComponent: PropTypes.object
    };

    state = {
        passwordVisible: false,
        showPwdFocused: false
    };

    togglePasswordVisible = () => {
        this.setState( {
            passwordVisible: !this.state.passwordVisible
        } );
    };

    onCheckboxFocus = event => {
        this.setState( { showPwdFocused: true } );
    };

    onCheckboxBlur = event => {
        this.setState( { showPwdFocused: false } );
    };

    render() {
        const {
            passwordVisible,
            showPwdFocused
        } = this.state;

        const {
            id,
            label,
            name,
            value,
            disabled,
            tabIndex,
            onChange,
            onKeyPress,
            onFocus,
            onBlur,
            helpComponent,
            showPasswordLabel
        } = this.props;

        const pwdInputOpts = {
            id,
            type: passwordVisible ? 'text' : 'password',
            name,
            value,
            tabIndex,
            disabled,
            onChange,
            onKeyPress,
            onFocus,
            onBlur
        };

        const icon = passwordVisible ? <EyeOpenIcon aria-hidden="true" /> : <EyeClosedIcon aria-hidden="true" />;

        return (
            <div className="password-input">
                <div className="input-wrap">
                    { helpComponent }
                    <label htmlFor={ id }>{ label }</label>
                    <input { ...pwdInputOpts } required={ true } />
                    <label className={ 'eye' + ( showPwdFocused ? ' focused' : '' ) }>
                        { icon }
                        <span className="sr-only">
                            <span>{ showPasswordLabel || 'Show password' }</span>
                            <input
                                type="checkbox"
                                onClick={ this.togglePasswordVisible }
                                onFocus={ this.onCheckboxFocus }
                                onBlur={ this.onCheckboxBlur }
                                className="pwd-toggle"
                            />
                        </span>
                    </label>
                </div>
            </div>
        );
    }
}

export default PasswordInput;
